import { runOnBrowserFeatureInit } from '@frontend/vanilla/core';

import { LoginDurationBootstrapService } from './login-duration-bootstrap.service';

export function provide() {
    return [runOnBrowserFeatureInit(LoginDurationBootstrapService)];
}
